import React, { useEffect, useMemo, useState } from "react";
import { API } from "../../../API";
import { getClass, getTeacherFullName, getTeacherState } from "../../../Helper";
import AdminWrapper from "../AdminWrapper";
import SwitchMenuBar from "../../../Components/SwitchMenuBar/SwitchMenuBar";
import ReactTable from "react-table-6";
import Pagination from "@mui/material/Pagination";
import FormDropdown from "../../../Components/FormField/FormDropdown";
import FormMultiSelect from "../../../Components/FormField/FormMultiSelect";
import FormDatePicker from "../../../Components/FormField/FormDatePicker";
import moment from "moment";
import { State } from "country-state-city";
import SearchBar from "../../../Components/SearchBar/SearchBar";

function AllAvailabilityTable() {
  const initialFilterState = { name: "", email: "", state: "", can_deliver: [], availability_date: "" }
  const [allUsers, setAllUsers] = useState([]);
  const [allAvailability, setAllAvailability] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filter, setFilter] = useState(initialFilterState)
  const [loading, setLoading] = useState(false);
  const className = getClass().map(cls => cls.key)

  const getUsers = () => {
    API.allTeachersForAllocate()
      .then(function (result) {
        setAllUsers(result.data);
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  useEffect(() => {
    setLoading(true);
    getUsers();
  }, []);

  useEffect(() => {
    if (allUsers.length > 0) {
      getAllAvailability(1, 10, initialFilterState);
    }
  }, [allUsers])

  const getAllAvailability = (page, limit, filter) => {
    setLoading(true);
    API.getAllAvailability(page, limit, filter)
      .then(res => {
        // console.log(res.data)
        const totalPage = res.data.paginate.total_page
        if (page > totalPage) {
          setCurrentPage(totalPage)
          getAllAvailability(totalPage, limit, filter)
        } else {
          let users = res.data.users.filter((t) => !t.deleted_at)
          users.map(user => {
            user.stateData = getTeacherState(user)
            user.name = getTeacherFullName(user)
            if (user.deliver_arr && !(className.includes(user.deliver_arr[user.deliver_arr.length - 1]))) {
              user.deliver_arr.pop();
            }
            user.availabilities = user.rules && user.rules[0] && Object.values(user.rules[0])
              .filter((availability) => !availability.time.includes("Not Available"))
              .map((availability) => ({
                date: uniformDateStr(availability.date),
                day: availability.day,
                time: availability.time.includes("All")
                  ? ["All day"]
                  : availability.time.map((timeSlot) =>
                    timeSlot === "Morning"
                      ? "AM "
                      : timeSlot === "Afternoon"
                      ? "PM "
                      : timeSlot === "Evening"
                        ? "Eve "
                        : ""
                  ),
              }))
              .filter((availability) => availability.date >= today)
          })
          setAllAvailability(users);
          setPageCount(totalPage)
          setLoading(false);
        }
      })
      .catch(function (err) {
        console.log(err);
        setLoading(false);
      });
  }

  const uniformDateStr = (dateStr) => {
    let arr = dateStr.split("-");
    return arr[0].length === 4 ? dateStr : arr.reverse().join("-");
  };

  const today = new Date().toISOString().slice(0, 10);

  const columns = useMemo(() => [
    {
      Header: "Teacher Name",
      width: 180,
      Cell: (props) => <BasicCell content={props.original.name} />,
      filterable: true,
      Filter: () => (
        <FormDropdown
          value={filter.name}
          onChange={(e) => {
            filter.name = e.target.value
            setFilter(filter)
            setCurrentPage(1)
            getAllAvailability(1, pageSize, filter)
          }}
        >
          <option value="">
            Select Name
          </option>
          {allUsers && allUsers.map((user) =>
            <option value={user.first_name + " " + user.last_name}>{getTeacherFullName(user)}</option>)}
        </FormDropdown>)
    },
    {
      Header: "Email",
      width: 270,
      Cell: (props) => <BasicCell content={props.original.email} />
    },
    {
      Header: "Contact Number",
      width: 120,
      Cell: (props) => <BasicCell content={props.original.contact_number || "N.A."} />
    },
    {
      Header: "State",
      width: 70,
      Cell: (props) => <BasicCell content={props.original.stateData} />,
      filterable: true,
      Filter: () => (
        <FormDropdown
          value={filter.state}
          onChange={(e) => {
            filter.state = e.target.value
            setFilter(filter)
            setCurrentPage(1)
            getAllAvailability(1, pageSize, filter)
          }}
        >
          <option value="">
            All
          </option>
          {State.getStatesOfCountry("AU").map((state) =>
            <option value={state.isoCode}>{state.isoCode}</option>)}
        </FormDropdown>)
    },
    {
      Header: "Suburb",
      width: 120,
      Cell: (props) => <BasicCell content={props.original.suburb || "N.A."} />
    },
    {
      Header: "Can Deliver",
      width: 300,
      Cell: (props) =>
        props.original.deliver_arr && props.original.deliver_arr.length > 0 ? (
          <CanDeliverCell types={props.original.deliver_arr} />
        ) : (
          <BasicCell content="N.A." />
        ),
      filterable: true,
      Filter: () => {
        return (
          <FormMultiSelect
            className="mt-3"
            name="canDeliver"
            id="canDeliver"
            value={filter.can_deliver}
            onChange={handleCanDeliverFilterChange}
            options={className.map(cls => ({ value: cls, label: cls }))}
            isSearchable
            isMulti
            noMargin
          />
        );
      },
    },
    {
      Header: "Availabilities",
      width: 320,
      Cell: (props) =>
        props.original.availabilities &&
        props.original.availabilities.length > 0 ? (
          <AvailabilitiesCell
            availabilities={props.original.availabilities}
          />
        ) : (
          <BasicCell content="N.A." />
        ),
      filterable: true,
      Filter: () => {
        return (
          <FormDatePicker
            placeholderText="Select date"
            value={filter.availability_date}
            onChange={(e) => {
              filter.availability_date = moment(e).format("DD-MM-YYYY")
              setFilter(filter)
              setCurrentPage(1)
              getAllAvailability(1, pageSize, filter)
            }}
            isClearable
            dateFormat="DD-MM-YYYY"
            className="datepicker-2 mt-3"
            maxWidth
            noMargin
          />
        );
      },
    }
  ]);

  const handleCanDeliverFilterChange = (e) => {
    filter.can_deliver = e === null ? [] : e.length > 0 ? e : []
    setFilter(filter)
    setCurrentPage(1)
    getAllAvailability(1, pageSize, filter)
  }

  const BasicCell = ({ content }) => (
    <div className="basic-cell-container">
      <div className="basic-cell-child-element">{content}</div>
    </div>
  );

  const CanDeliverCell = ({ types }) => (
    <div className="can-deliver-cell-container">
      {types.map((type) => (
        <div key={type} className="can-deliver-cell-child-element">
          {type}
        </div>
      ))}
    </div>
  );

  const AvailabilitiesCell = ({ availabilities }) => (
    <div className="availabilities-cell-container">
      {availabilities.map((availability) => (
        <Availability availability={availability} key={availability.date} />
      ))}
    </div>
  );

  const Availability = ({ availability }) => (
    <div className="availabilities-cell-item">
      <span className="availabilities-date-item">{moment(availability.date).format("DD-MM-YYYY")}</span>
      <span className="availabilities-day-item">{availability.day} </span>
      {availability.time.map((timeSlot, idx) => (
        <span key={idx}>{timeSlot}</span>
      ))}
    </div>
  );

  return (
    <AdminWrapper>
      <SwitchMenuBar isViewAsTeacher />
      <div className="all-availability-table-container">
        <h1 className="text-3xl font-bold text-center">All Availabilities</h1>
        <div className="mb-4 mx-1">
          <SearchBar
            onChange={(e) => {
              filter.email = e.target.value
              setFilter(filter)
            }}
            placeholder="Search by email"
            // value={filter.email}
            handleSearch={() => {
              setCurrentPage(1)
              getAllAvailability(1, pageSize, filter)
            }}
          />
        </div>
        <ReactTable
          className="-striped -highlight"
          showPagination={false}
          data={allAvailability}
          sortable={false}
          loading={loading}
          pageSize={pageSize}
          columns={columns}
        />
        <div className="d-flex justify-content-center">
          <Pagination
            className="mt-3 mr-5"
            page={currentPage}
            count={pageCount}
            onChange={(e, value) => {
              getAllAvailability(value, pageSize, filter);
              setCurrentPage(value)
            }}
          />
          <FormDropdown
            value={pageSize}
            onChange={(e) => {
              console.log(e.target.value)
              getAllAvailability(currentPage, e.target.value, filter);
              setPageSize(e.target.value)
            }}
          >
            <option value={5}>5 rows</option>
            <option value={10}>10 rows</option>
            <option value={20}>20 rows</option>
            <option value={50}>50 rows</option>
            <option value={100}>100 rows</option>
          </FormDropdown>
        </div>
      </div>
    </AdminWrapper>
  );
}

export default AllAvailabilityTable;